module.exports = __webpack_public_path__ + "static/media/arrow-icon.b52241a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-icon.svg
// module id = 240
// module chunks = 0